import { FETCH_PERMISSIONS } from '../../../constants/ActionTypes'

const initialState = {
  permissions: []
}
const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PERMISSIONS:
      return {
        ...state,
        permissions: [...action.data]
      }
    default:
      return state
  }
}
export default permissionReducer
